// ============================================
// COMPANYSURVEYSPAGE.JSX - Company Surveys Sub-Page
// ============================================

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetCompanyByIdQuery } from "../../../services/api";
import SurveySection from "./SurveySection";
import "./CompanyDetails.css";
import "./CompanySurveys.css";

/**
 * CompanySurveysPage Component
 * Sub-page for managing company surveys and viewing results
 */
export default function CompanySurveysPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  // ==================== API QUERIES ====================
  const { data: companyData } = useGetCompanyByIdQuery(id);
  const companyName = companyData?.name || "Loading...";

  // ==================== RENDER ====================
  return (
    <div className="cd-company-details">
      <div className="welcome" onClick={() => navigate(`/admin/companies/${id}`)}>
        &larr; Back to {companyName}
      </div>
      <h1 className="username">{companyName} - Surveys</h1>

      <SurveySection companyId={id} />
    </div>
  );
}
